module.exports = __webpack_public_path__ + "img/ic-other.99c3e012.svg";